<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <funds-form :fund="fund" :disabled="disabled" @activate-mod="activateMod()" @save-archive-web="saveArchiveWeb()"
                    @click="updateFund()"
                    :showLabels="true" :showSave="true"></funds-form>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">Bobine</h3>
          </div>
          <div class="box-body">
            <reels-tab v-bind="{requestFunction}" ref="reelsTab"/>
          </div>

          <div class="box-footer" v-if="$accessControl.isOperator($store.state.profile.profile)">
            <div class="row">
              <div class="col-md-12 text-right">
                <div class="row">
                  <div class="col-md-3 col-md-offset-6 col-sm-3 col-sm-offset-5">
                    <router-link :to="'/reel'" class="btn btn-primary">
                      Nuova bobina
                    </router-link>
                  </div>
                  <div class="col-md-3 col-sm-4">
                    <div class="input-group col-md-12">
                      <input v-model="massiveReelsInsert" type="text" class="form-control"/>
                      <span class="input-group-btn">
                                                <button type="button"
                                                        class="btn btn-primary" v-on:click.prevent="reelsMassiveInsert">Inserimento massivo bobine</button>
                                            </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import types from '../../store/mutation-types'
import fundsApi from '../../api/funds'
import fundsForm from './Form.vue'
import reelsTab from '../components/ReelsTab'
import reels from '@/api/reels'
import Reel from '@/models/reel'

export default {

  components: {
    fundsForm,
    reelsTab
  },

  data () {
    return {
      fund: false,
      disabled: true,
      interval: null,
      massiveReelsInsert: 1
    }
  },

  beforeCreate () {
    fundsApi.show(this.$route.params.id)
      .then((response) => {
        this.fund = response
        this.$store.commit(types.SET_ACTUAL_FUND, _.cloneDeep(response))
      })
    this.$emit('addBackgroundColor', 'rgb(138,163,157)')
  },

  created () {
    this.$store.commit(types.SET_HEADER_STATE, {
      pageTitle: 'Scheda fondo',
      createButton: {
        display: true,
        text: 'Nuovo fondo',
        to: '/fund'
      }
    })
    this.interval = setInterval(() => {
      if (!this.disabled) {
        fundsApi.update(this.$route.params.id, this.fund)
      }
    }, process.env.AUTOSAVE_TIMEOUT)
  },

  beforeDestroy () {
    clearInterval(this.interval)
  },

  methods: {
    activateMod () {
      this.disabled = !this.disabled
    },
    updateFund () {
      this.loader = true
      return fundsApi.update(this.$route.params.id, this.fund)
        .then((response) => {
          toastr.success('Il fondo è stato salvato correttamente')
          this.loader = false
          this.disabled = true
        })
        .catch((response) => {
          this.loader = false
        })
    },
    saveArchiveWeb () {
      this.loader = true
      return fundsApi.saveArchiveWeb(this.$route.params.id)
        .then((response) => {
          toastr.success('Il fondo è stato salvato correttamente')
          this.loader = false
          this.disabled = true
        })
        .catch((response) => {
          this.loader = false
        })
    },
    requestFunction (query) {
      return fundsApi.reels(this.$route.params.id, query)
    },
    reelsMassiveInsert () {
      this.$refs.reelsTab.toggleLoading()
      return reels.storeMassive(new Reel(true, {
        count: this.massiveReelsInsert,
        fund_id: this.fund.id
      }, this.$store.state.profile.profile.person.data)).then(response => {
        this.$refs.reelsTab.refresh()
        this.$refs.reelsTab.toggleLoading()
      })
    }
  }
}
</script>

<style>
tr {
  cursor: pointer;
}

</style>

<!--$request->get('reel') = {array} [10]-->
<!--emptyNote = "/"-->
<!--isNew = false-->
<!--digitazion = {array} [1]-->
<!--restoration = {array} [1]-->
<!--description = {array} [1]-->
<!--filmFormats = {array} [0]-->
<!--filmBrands = {array} [0]-->
<!--restauro = {int} 0-->
<!--note = "/"-->
<!--fundId = {int} 141-->



// WEBPACK FOOTER //
// src/components/funds/Show.vue